export const decodePhotoUrl = (endocdedUrl) => {
  return endocdedUrl.replace("#", "https://")
    .replace("$", ".bstatic.com/images/hotel/max500/")
}
